import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';

import UserAvatar from 'components/UserAvatar';
import Link from 'components/Link';
import './style.scss';

class Reply extends Component {

  constructor() {
    super();
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  handleVisibilityChange(isVisible) {
    if(isVisible && this.props.onDidBecomeVisible) {
      this.props.onDidBecomeVisible();
    }
  }

  render() {
    const { animateHover = true } = this.props;

    const className = classnames({
      'Reply': true,
      'is-unread': this.props.isUnread,
      'is-empty': this.props.isEmpty,
      'animate-hover': animateHover
    });

    return (
      <li className={className}>
        <VisibilitySensor onChange={this.handleVisibilityChange} />

        <div className="date">{this.props.since}</div>

        <div className="avatar">
          <UserAvatar letter={this.props.avatarLetter} imageUrl={this.props.avatarImageUrl} />
        </div>

        <div className="author">
          <h4>{this.props.authorName}</h4>
        </div>

        <div className="snippet">
          <p>{this.props.children}</p>
        </div>

        {(() => {
          if(this.props.to) {
            return <Link to={this.props.to}>&nbsp;</Link>;
          }
        })()}
      </li>
    );
  }
}

Reply.propTypes = {
  isUnread: PropTypes.bool,
  since: PropTypes.string ,
  avatarLetter: PropTypes.string,
  avatarImageUrl: PropTypes.string,
  authorName: PropTypes.string,
  to: PropTypes.string,
  children: PropTypes.node,
  animateHover: PropTypes.bool,
  onDidBecomeVisible: PropTypes.func,
  isEmpty: PropTypes.bool
};

export default Reply;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/RepliesList/Reply/index.js
 **/